import './style';
import App from './components/app';
import 'preact-material-components/style.css';

export default App;
